import React from 'react';
import { motion } from 'framer-motion';

interface FloatingTextProps {
  text: string;
  color: string;
}

const FloatingText: React.FC<FloatingTextProps> = ({ text, color }) => {
  // Random horizontal position
  const randomX = Math.random() * 40 + 30; // 30-70% from left

  return (
    <motion.div
      className={`absolute font-bold text-lg ${color} pointer-events-none drop-shadow-lg`}
      initial={{ 
        opacity: 1, 
        y: '60%', 
        x: `${randomX}%`,
        scale: 0.5
      }}
      animate={{ 
        opacity: 0, 
        y: '20%',
        scale: 1.2
      }}
      transition={{ 
        duration: 2,
        ease: "easeOut"
      }}
      style={{
        textShadow: '0 0 10px rgba(0,0,0,0.8), 0 0 20px currentColor'
      }}
    >
      {text}
    </motion.div>
  );
};

export default FloatingText;
